import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ObservableRequestService } from 'app/services/observable-request.service';
import { ConstantsService } from 'app/services/constants-service';

import { RiskProfile } from 'app/shared/models/risk-profile.model';

/**
 * Servie to handle the Risk Profile Details.
 */
@Injectable()
export class RiskProfileService {

    constructor(private requestService: ObservableRequestService) {
    }

    getRiskProfileScore(clientId): Observable<any> {
        return this.requestService.getRequest(ConstantsService.RISK_PROFILE_SCORE + '/' + clientId);
    }

    getRiskProfiles(clientId): Observable<any> {
        return this.requestService.getRequest(ConstantsService.RISK_PROFILE + '/' + clientId);
    }

    updateRiskProfile(riskProfile: RiskProfile): Observable<any> {
        return this.requestService.putRequest(
            ConstantsService.RISK_PROFILE + '/' + riskProfile.clientId
            , riskProfile
            , this.requestService.getJSONContentType());
    }

    addRiskProfile(riskProfile: RiskProfile): Observable<any> {
        return this.requestService.postRequest(
            ConstantsService.RISK_PROFILE
            , riskProfile
            , this.requestService.getJSONContentType());
    }

}



// WEBPACK FOOTER //
// ./src/app/clients/client/header/riskprofile/risk-profile.service.ts